import api from '../utils/api';


export const getMarketPlace = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/marketplace/getAllMarketPlace`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const getMarketPlaceList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: '/api/marketplace/getAll',
        method: "POST",
         data: data,
        ...options,
    });
}; 
export const getMarketPlaceByIdEdit = (marketPlaceBaseId) => {
    return api({
        url: '/api/marketplace/getMarketPlaceByBaseId/' + marketPlaceBaseId,
        method: 'GET'
    })
} 
export const submitMarketPlace = (marketplace) => {
    let url = '/api/marketplace/addUpdateMarketPlace';
    return api({
        url: url,
        method: 'POST',
        data: marketplace
    })
}
export const submitMyMarketPlaceList = (marketplace) => {
    let url = '/api/marketplace/addUpdateMyMarketPlaceList';
    return api({
        url: url,
        method: 'POST',
        data: marketplace
    })
}

export const deleteMarketPlace = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/marketplace/deleteMarketPlace/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}

export const AddUpdatePin = (marketplace) => {
    let url = '/api/marketplace/AddUpdatePin';
    return api({
        url: url,
        method: 'POST',
        data: marketplace
    })
}  
export const getMarketPlaceTypes = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/marketplace/getMarketPlaceTypes',
        method: 'GET',
        ...options,
    });
}; 
